import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=5cb82f82&scoped=true"
import script from "./AppIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=5cb82f82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb82f82",
  null
  
)

export default component.exports